<template>
  <el-dialog
    title="批量导出"
    :visible.sync="dialogVisible"
    width="420px"
    custom-class="batch-month-export-dialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <div class="batch-export-body">
      <div class="field">
        <div class="field-label">开始月份</div>
        <el-date-picker
          v-model="Month_start"
          type="month"
          placeholder="请选择开始月份"
          format="yyyy-MM"
          value-format="yyyy-MM"
          clearable
          class="field-picker"
        />
      </div>
      <div class="field">
        <div class="field-label">结束月份</div>
        <el-date-picker
          v-model="Month_end"
          type="month"
          placeholder="请选择结束月份"
          format="yyyy-MM"
          value-format="yyyy-MM"
          clearable
          class="field-picker"
        />
      </div>
      <div class="tip">将导出所选起止月份（含）之间的全部账单数据，例如 2026-01 至 2026-05。</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'BatchMonthExportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Month_start: '',
      Month_end: '',
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  methods: {
    handleConfirm() {
      if (!this.Month_start || !this.Month_end) {
        this.$message.warning('请选择开始月份和结束月份');
        return;
      }
      if (this.Month_start > this.Month_end) {
        this.$message.warning('开始月份不能晚于结束月份');
        return;
      }
      this.$emit('confirm', {
        Month_start: this.Month_start,
        Month_end: this.Month_end,
      });
    },
    handleClosed() {
      this.Month_start = '';
      this.Month_end = '';
    },
  },
};
</script>

<style scoped>
.batch-export-body {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.field {
  margin-bottom: 16px;
}

.field-label {
  margin-bottom: 8px;
  color: #606266;
  font-size: 14px;
  line-height: 1;
}

.field-picker {
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
}

.tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
</style>

<style>
/* append-to-body 后需非 scoped 才能作用到弹层内部 */
.batch-month-export-dialog {
  box-sizing: border-box;
}

.batch-month-export-dialog .el-dialog__body {
  overflow: hidden;
  padding: 16px 20px 8px;
}

.batch-month-export-dialog .field-picker.el-date-editor.el-input,
.batch-month-export-dialog .field-picker.el-date-editor.el-input .el-input__inner {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}
</style>
